// Reglas puras de Mis productos (búsqueda, filtro, textos); `node --test`.
// Doc: _docs/features/products/partner_products_index.md

// Misma normalización que ProductsHelper#catalog_search_key: sin acentos, minúsculas, espacios simples.
export function normalizeText(value) {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ")
}

// Sin término todo coincide; la fila entra por su nombre (la sección la decide el controller).
export function rowMatches(name, query) {
  if (!query) return true
  return String(name ?? "").includes(query)
}

export function passesFilter(active, status) {
  if (status === "on") return active
  if (status === "off") return !active
  return true
}

// Estado de una fila por data-active; sin el atributo la fila es simple (cuenta como activa)
export function rowIsActive(value) {
  return value !== "false"
}

export function plural(count, one, many) {
  return `${count} ${count === 1 ? one : many}`
}

export function groupLabel(count, open) {
  return open ? "Ocultar inactivos" : `Ver ${plural(count, "inactivo", "inactivos")}`
}

export function mixLabel(active, inactive) {
  return `${plural(active, "activo", "activos")} · ${plural(inactive, "inactivo", "inactivos")}`
}

export function footerLabel(products, sections) {
  return `Mostrando ${plural(products, "producto", "productos")} en ${plural(sections, "sección", "secciones")}`
}

// Orden: activas, luego inactivas, cada grupo por el data-order del servidor
export function sortedPartitions(rows) {
  const byOrder = (a, b) => a.order - b.order
  return {
    active: rows.filter((row) => row.active).sort(byOrder),
    inactive: rows.filter((row) => !row.active).sort(byOrder)
  }
}
